export default __webpack_public_path__ + "static/media/order-orange.d03ab6fa.svg";